import { motion } from "framer-motion";
import { ShieldCheck, BadgeDollarSign, Clock } from "lucide-react";

const VALUES = [
  { icon: ShieldCheck, title: "Licensed & Insured", desc: "Qualified plumbers, fully covered on every job." },
  { icon: BadgeDollarSign, title: "Upfront Pricing", desc: "Clear quotes before we start — no hidden extras." },
  { icon: Clock, title: "Reliable & On Time", desc: "We turn up when we say we will, and clean up after." },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="border-b border-[#111111]/15">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          data-testid="about-image-placeholder"
          className="relative bg-white flex flex-col border-b lg:border-b-0 lg:border-r border-[#111111]/15 overflow-hidden"
        >
          <div className="px-8 md:px-10 py-5 border-b border-[#111111]/15 flex flex-wrap items-center justify-between gap-2">
            <h3 className="font-display uppercase tracking-wide text-xl md:text-2xl" data-testid="about-image-caption">
              Instantaneous Hot Water Service Install
            </h3>
            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#003BFF]">
              Before &amp; After
            </span>
          </div>
          <img
            src="/assets/hot-water-before-after.webp"
            alt="Before and after of an instantaneous hot water service install by One Piece Maintenance"
            className="w-full h-auto block my-auto"
          />
        </motion.div>

        <div className="px-6 md:px-12 py-20 md:py-28 flex flex-col justify-center">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="text-xs font-bold uppercase tracking-[0.3em] text-[#003BFF] mb-6"
          >
            About Us
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display uppercase tracking-wide leading-[1.05] text-4xl md:text-6xl mb-8"
          >
            One Crew.<br />Every Job<br />
            <span className="text-[#003BFF]">Done Right.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-base md:text-lg text-[#555555] font-medium leading-relaxed max-w-lg mb-12"
          >
            One Piece Maintenance was established in 2022 and delivers expert
            plumbing across Melbourne's north and surrounding suburbs. We value
            quality workmanship and transparency with our customers — with
            proper diagnostics we make sure the right repairs are made, so you
            never waste time or money on unnecessary fees. We do right by our
            customers and leave every property in One Piece. Good trades can be
            hard to come by, so we strive to leave every customer satisfied.
          </motion.p>

          <div className="border-t border-[#111111]/15">
            {VALUES.map((v, i) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: 0.15 + i * 0.1 }}
                data-testid={`value-${i}`}
                className="flex items-start gap-5 py-6 border-b border-[#111111]/15 group"
              >
                <span className="w-11 h-11 shrink-0 border border-[#111111]/20 flex items-center justify-center transition-colors duration-300 group-hover:bg-[#003BFF] group-hover:border-[#003BFF]">
                  <v.icon className="w-5 h-5 transition-colors duration-300 group-hover:text-white" />
                </span>
                <div>
                  <h3 className="font-bold uppercase tracking-[0.12em] text-sm mb-1">{v.title}</h3>
                  <p className="text-sm text-[#555555] font-medium">{v.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
